<div class="wrapper-feedback-form">
    <div class="section-text row">
        <div class="section-btn">
            <button routerLink='/dashboard/product-manager' class="btn btn-back rounded-circle mt-2">
              <i class="fi-rr-arrow-alt-left"></i>
            </button>
        </div>
        <!--<div>
            <h1 class="title">Create Customer Product</h1>
        </div>-->
    </div>

    <div class="section-main">
      <form [formGroup]="customerProductForm" (ngSubmit)="createCustomerProduct()"  method="post">
            <div class="row" >
              <div class="message-info col-6" >
                <div class="card h-2 mt-4">
                    <!--<h4 class="title">Company address</h4>
                    <p class="subtitle">
                        The physical address of your store or place of business. If you don't have a
                        business address, enter the address from which you ship orders.
                    </p>-->
                    <div class="row mt-2">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                            <h4 class="title-2 mt-2">Product Name</h4>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                          <input class="form-control" formControlName="product_name"  type="text">
                        </div>
                    </div>
                  <!--  <div class="row mt-2">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                            <h4 class="title-2 mt-2">Country</h4>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                            <select formControlName="language_code" class="form-select" aria-label="Default select example">
                              <option selected>Select Country</option>
                              <option *ngFor="let c of country" value="{{c.country_code}}">{{ c.country_name }}</option>

                            </select>
                        </div>
                    </div>-->
                    <div class="row mt-3">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                            <h4 class="title-2 mt-2">Overview</h4>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                            <div class="form-group">
                                <!--<ckeditor [config]="ckConfig" [editor]="Editor"  formControlName="product_overview"  ></ckeditor>-->
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                            <h4 class="title-2 mt-2">Description</h4>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                            <div class="form-group">
                                <!--<ckeditor [config]="ckConfig" [editor]="Editor"  formControlName="product_desc"  ></ckeditor>-->
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-3">
                            <h4 class="title-2 mt-2">Image</h4>
                        </div>
                        <div class="col-12 col-sm-12 col-md-12 col-lg-9">
                            <div class="form-group">
                              <div class="col">
                                  <div class="section-upload" (click)="file.click()">
                                      <button *ngIf="!imgURL" class="btn btn-primary">Upload Image</button>
                                      <button *ngIf="imgURL" class="btn btn-primary float-center">Edit Image</button>

                                      <input #file class="d-none" type="file" accept="image/*" (change)="preview(file.files)">
                                      <img  *ngIf="imgURL" [src]="imgURL" class="image-uploaded">
                                  </div>
                              </div>
                            </div>
                        </div>
                    </div>

                    <div align="right" class=" mt-3">
                      <button  class="btn btn-blue-small" >Submit Feedback</button>
                    </div>

                </div>
              </div>
            </div>
        </form>
    </div>
</div>
